"use client";

import ScrollyImage from "@/components/common/ScrollyImage";
import { works } from "./data";
import "./style.scss";
import Link from "next/link";

const Work = () => {
	return (
		<section className="work-section">
			<h2>Work</h2>
			<div className="work-section__content">
				<div className="work-section__content-1">
					{works.slice(0, 2).map((work) => (
						<Link href={`/projects/case-studies/${work.id}`} key={work.id} className="work-item">
							<ScrollyImage className="work-item__image-wrapper">
								<img src={`/work/${work.id}.webp`} alt={work.title} width={work.width} height={work.height} className="work-item__image" style={{ width: `${work.width / 10}rem`, height: `${work.height / 10}rem` }} />
							</ScrollyImage>
							<div className="work-item__info">
								<div className="work-item__text">
									<p className="work-item__category">{work.category}</p>
									<h3 className="work-item__title">{work.title}</h3>
									<p className="work-item__description">{work.description}</p>
								</div>
								<svg className="work-item__arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</div>
						</Link>
					))}
				</div>
				<div className="work-section__content-2">
					{works.slice(2, 3).map((work) => (
						<Link href={`/projects/case-studies/${work.id}`} key={work.id} className="work-item">
							<ScrollyImage className="work-item__image-wrapper">
								<img src={`/work/${work.id}.webp`} alt={work.title} width={work.width} height={work.height} className="work-item__image" style={{ width: `${work.width / 10}rem`, height: `${work.height / 10}rem` }} />
							</ScrollyImage>
							<div className="work-item__info">
								<div className="work-item__text">
									<p className="work-item__category">{work.category}</p>
									<h3 className="work-item__title">{work.title}</h3>
									<p className="work-item__description">{work.description}</p>
								</div>
								<svg className="work-item__arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</div>
						</Link>
					))}
				</div>

				<div className="work-section__content-3">
					{works.slice(3, 5).map((work) => (
						<Link href={`/projects/case-studies/${work.id}`} key={work.id} className="work-item">
							<ScrollyImage className="work-item__image-wrapper">
								<img src={`/work/${work.id}.webp`} alt={work.title} width={work.width} height={work.height} className="work-item__image" style={{ width: `${work.width / 10}rem`, height: `${work.height / 10}rem` }} />
							</ScrollyImage>
							<div className="work-item__info">
								<div className="work-item__text">
									<p className="work-item__category">{work.category}</p>
									<h3 className="work-item__title">{work.title}</h3>
									<p className="work-item__description">{work.description}</p>
								</div>
								<svg className="work-item__arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</div>
						</Link>
					))}
				</div>
			</div>
		</section>
	);
};

export default Work;
